import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    border: '2px solid red',
                    borderRadius: '8px',
                    backgroundColor: '#ffe6e6'
                }}>
                    <h2>🚨 Something went wrong</h2>
                    <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                        <summary>Error Details (click to expand)</summary>
                        <div style={{ marginTop: '10px', fontSize: '12px', fontFamily: 'monospace' }}>
                            <strong>Error:</strong> {this.state.error && this.state.error.toString()}
                            <br />
                            <strong>Stack:</strong> {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </div>
                    </details>
                    <div style={{ marginTop: '20px' }}>
                        <button 
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#ff4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            Reload Page
                        </button>
                        <button 
                            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#4444ff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Try Again
                        </button>
                    </div>
                    <div style={{ marginTop: '20px', fontSize: '14px' }}>
                        <strong>Troubleshooting:</strong>
                        <ul>
                            <li>Check browser console for additional errors</li>
                            <li>Try refreshing the page</li>
                            <li>Clear browser cache and cookies</li>
                            <li>Try in incognito/private mode</li>
                        </ul>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;